export const REQUEST_CUSTOMER_DATASOURCE_LICENCES = 'REQUEST_CUSTOMER_DATASOURCE_LICENCES';
export const RECEIVE_CUSTOMER_DATASOURCE_LICENCES = 'RECEIVE_CUSTOMER_DATASOURCE_LICENCES';
export const FAIL_CUSTOMER_DATASOURCE_LICENCES_FETCH = 'FAIL_CUSTOMER_DATASOURCE_LICENCES_FETCH';
